import { newIdempotencyKey } from '@/shared/lib/auth';

const STORAGE_KEY = 'byq.offline-sale.idempotencyKey';
const PREFIX = 'admin-offline-';
const MAX_LENGTH = 100;

function storage(): Storage | null {
  try {
    return globalThis.sessionStorage ?? null;
  } catch {
    return null;
  }
}

function isSaleKey(value: string | null): value is string {
  return Boolean(value && value.startsWith(PREFIX) && value.length <= MAX_LENGTH);
}

/** One key for the current sale. Reused across checkout retries until a new sale starts. */
export function readOrCreateSaleIdempotencyKey(): string {
  const store = storage();
  const existing = store?.getItem(STORAGE_KEY) ?? null;
  if (isSaleKey(existing)) return existing;
  return rotateSaleIdempotencyKey();
}

/** Call only after a successful checkout, or when the admin explicitly starts over. */
export function rotateSaleIdempotencyKey(): string {
  const key = `${PREFIX}${newIdempotencyKey()}`.slice(0, MAX_LENGTH);
  storage()?.setItem(STORAGE_KEY, key);
  return key;
}
